<template>
  <div>
    <navigation/>
    <!--Banner Wrap Start-->
    <div class="iner_banner">
      <div class="container">
        <h5>Applicants List</h5>
        <div class="banner_iner_capstion">
          <ul>
            <li>
              <router-link to="/">Home</router-link>
            </li>
            <li>
              <router-link to="/partners">applicants</router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!--Banner Wrap End-->

    <!--Iqoniq Content Start-->
    <div class="iq_content_wrap">
      <!--Partner START-->
      <section class="about-us-section">
        <div style="padding: 0 20px">
          <div class="col-12 table-responsive">
            <table class="text-nowrap">
              <tr>
                <th>S/N</th>
                <th>Surname</th>
                <th>Name</th>
                <th>Purpose</th>
                <th>Destination</th>
                <th>Phone</th>
                <th>Email</th>
                <th>Created</th>
                <th>Status</th>
              </tr>

              <tr v-for="(application, i) in applications" v-bind:key="i" class="text-left">
                <td>{{ i + 1 }}</td>
                <td>
                  {{ application.surname }}
                </td>
                <td>
                  {{ application.name }}
                </td>
                <td>{{ application.purpose }}</td>
                <td>{{ application.destination }}</td>
                <td>{{ application.number }}</td>
                <td>{{ application.email }}</td>
                <td>{{parseDateToDateStr(application.dateCreated)}}</td>
                <td>
                  <select class="form-control-lg" :value="application.status" @change="updateApplicationStatus(application, $event.target.value)">
                    <option value="accepted">Accepted</option>
                    <option value="processing">Processing</option>
                    <option value="pending">Pending</option>
                    <option value="rejected">Rejected</option>
                  </select>
                </td>
              </tr>

            </table>

          </div>
          <button style="background-color:#c9a63c; padding:5px;margin-top: 10px">
            <router-link to="/">LOGOUT</router-link>
          </button>
        </div>
      </section>
      <!--APartner End-->
    </div>
    <!--Iqoniq Content End-->
    <footers/>
  </div>
</template>
<script>
import navigation from './navigation.vue'
import footers from './footer.vue'
import {firestoreDB} from './firebase.js'
import ApplicationService from "@/services/application.service";
import {parseDateToDateStr} from "@/utils/dateTime.util";
import ApplicationModel from "@/models/application.model";

export default {
  name: 'Applicants',
  components: {
    navigation, footers
  },
  data() {
    return {
      applications: [],
      loading: true,
      service : new ApplicationService()
    }

  },
  firestore() {
    return {

      applications: firestoreDB.collection('application')
    }
  },
  created() {
    this.getApplications().then(()=>this.loading=false);
  },
  methods: {
    parseDateToDateStr,
    updateApplicationStatus(application, status){
      application.status = status;
      this.service.updateApplication(application);
    },
    async getApplications() {
      this.applications = await this.service.getApplications();
    },
  },

}
</script>
<style>
.iq_heading_1 h4:before, .iq_heading_1 h5:before {
  background-color: #c9a63c
}

.iq_heading_1 h5 {
  margin: 15px 0
}

.categries-list li:before {
  float: left;
  content: "\f192";
  color: #c9a63c !important;
  margin: 0 15px 0 0;
  color: currentColor;
  font-family: "FontAwesome";
}

.categries-list, .iq_heading_1 h5 {
  color: #777777
}

.partner {
  color: #777777;
  line-height: 26px;
  margin: 0 0 15px;
}

.iq_heading_1.text-left h5:before {
  left: 0;
  right: auto;
}

@media (max-width: 767px) {
  .iq_heading_1.text-left h5::before {
    right: 0;
  }
}

.iq_heading_1 h5:before {
  content: "";
  position: absolute;
  bottom: 0px;
  left: 0px;
  top: 40px;
  right: 0px;
  margin: auto;
  width: 100px;
  height: 1px;
}

.iq_heading_1 h5:before, .iq_heading_1 h5:before {
  background-color: #c9a63c;
}

table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td, th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

@media only screen and (min-width: 20px) and (max-width: 920px) {
  td, th {
    padding: 1vh
  }
}

tr:nth-child(even) {
  background-color: #dddddd;
}
</style>
